if (typeof cpac !== 'undefined') {
    cpac.payroll = {
    
        adjustmentNum:  0, // current new adjustment row id
        currentlySaving: '',    // id of tr that is currently saving. unti-dblclick
    
        viewQuestionArea: function ()
        {
            try {
                var qArea = $('question-area');
                if (qArea.style.display == 'none') {
                    // get current question text
                    var qBody = $('view-question-body');
                    var txt = this.br2nl(qBody.innerHTML);
                    var textObj = qArea.down('textarea');
                    textObj.value = txt;
    
                    var qView = $('view-question');
                    if (qView.style.display != 'none') {
                        Effect.toggle(qView, 'blind', 0.2);
                    }
                    Effect.toggle(qArea, 'blind', 0.2);
                }
            } catch(e) {
                cpac.error(e);
            }
        },
    
        saveQuestionArea: function(formId, url) {
            try {
                var data = $j('#' + formId).serialize();
                data += '&question=' + this.nl2br($j('#payroll-question').val());
    
                // save question
                $j.caAjax({
                    type: 'post',
                    url: url,
                    data: data,
                    dataType: 'json',
                    loadingSplash: true,
                    success: function (response) {
                        if (response.status) {
                            $j.caAlert(
                                'Your question is now saved.',
                                'Question saved',
                                {
                                    type: 'alert'
                                }
                            );
                        } else {
                            $j.caAlert(response.errorMessages);
                        }
                    }
                });
            } catch (e) {
                cpac.error(e);
            }
        },
    
        hideQuestionArea: function ()
        {
            var qArea = $('question-area');
            var qView = $('view-question');
    
            if (qArea && qArea.style.display != 'none') {
    
                Effect.toggle(qArea, 'blind', 0.2);
            }
            if (qView && qView.style.display == 'none') {
                var qBody = $('view-question-body');
                if (qBody.innerHTML.length > 0) {
                    Effect.toggle(qView, 'blind', 0.2);
                }
            }
        },
    
    
    
        br2nl: function (text)
        {
            text = text.replace(/<br\s*\/?>/mgi,"\n");
            return text;
        },
    
        nl2br: function (text)
        {
            // trim
            text = text.replace(/(^\s+)|(\s+$)/g, "");
            var breakTag = '<br>';
            return text.replace(/\n/g, breakTag);
        },
    
        editModeOn: function (trRow)
        {
            Element.addClassName(trRow, 'editMode');
    
            editFields = $(trRow).select('.edit-field');
            for (i=0; i<editFields.length; i++) {
                inputObj = editFields[i];
                spanObj = inputObj.previousSibling;
                if (spanObj) Element.hide(spanObj);
                Element.show(inputObj);
            }
        },
    
        saveRow: function (trRow, url, totalId)
        {
            var editFields = $(trRow).select('.edit-field');
            var totalField = $(trRow).down('.total');
            var totalVal = 0;
            var saveData = '';
            for (i=0; i<editFields.length; i++) {
                inputObj = editFields[i];
                spanObj = inputObj.previousSibling;
                if (inputObj.tagName == 'INPUT') {
                    floatVal = parseFloat(inputObj.value);
                    isFee = Element.hasClassName(inputObj, 'fee');
                    if (isFee && !isNaN(floatVal)) {
                        if (!spanObj || spanObj.innerHTML != floatVal.toFixed(2)) {
                            saveData += '&' + Form.Element.serialize(inputObj);
                        }
                    } else if (isFee && isNaN(floatVal)) {
                        alert('Wrong data format');
                        inputObj.focus();
                        return false;
                    } else {
                        isRequired = Element.hasClassName(inputObj, 'required');
                        if (isRequired || !spanObj || spanObj.innerHTML != inputObj.value) {
                            saveData += '&' + Form.Element.serialize(inputObj);
                        }
                    }
                }
            }
            if ( saveData > '') {
                callBack = function (result, trRow)
                {
                    skipTotal = false;
                    if (result.id) {
                        var idObj = $(trRow).down('.id');
                        if (idObj) {
                            idObj.value = result.id;
                        }
                    }
                    if (result.total != undefined) {
                        var totalObj = $(trRow).down('.total');
                        prevTotalVal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                        prevTotalVal = isNaN( prevTotalVal ) ? 0 : prevTotalVal;
                        if (totalObj) {
                            // update global total
                            var globTotalObj = $(result.totalId);
                            if (globTotalObj) {
                                var currentTotal = parseFloat(globTotalObj.innerHTML.replace(/\s/g, ''));
                                currentTotal = isNaN( currentTotal ) ? 0 : currentTotal;
                                currentTotal = currentTotal - prevTotalVal;
                                currentTotal = currentTotal + parseFloat(result.total);
                                currentTotal = parseFloat(currentTotal);
                                globTotalObj.innerHTML = currentTotal.toFixed(2);
                            }
                            resTotal = parseFloat(result.total);
                            totalObj.innerHTML = resTotal.toFixed(2);
                        }
                        skipTotal = true
                    }
                    if (result.remove_class_name) {
                        while (obj = $(trRow).down('.' + result.remove_class_name)) {
                            Element.removeClassName(obj, result.remove_class_name);
                        }
                    }
                    cpac.payroll.editModeOff(trRow, 1, totalId, skipTotal);
                }
                this.processDataSaving(url, saveData, trRow, callBack);
            } else {
                cpac.payroll.editModeOff(trRow, 0);
            }
        },
    
        processDataSaving: function (url, saveData, trRow, callBack) {
            if (this.currentlySaving != '') {
                return false;
            }
            if(typeof(showAjaxStarted) == 'function') showAjaxStarted();
            this.currentlySaving = trRow;
            new Ajax.Request(url, {
                method:'post',
                parameters: $('filter_form').serialize() + saveData + '&ajax=true',
                onSuccess: function(transport){
                    cpac.payroll.currentlySaving = '';
                    if(typeof(showAjaxFinished) == 'function') showAjaxFinished(transport);
                    var result = transport.responseText.evalJSON();
                    if(typeof(result) == 'object') {
                        if (result.error == '') {
                            callBack(result, trRow);
                        } else {
                            cpac.errorMessage(result.error);
                        }
                    } else {
                        alert('Some error has occured: empty result returned.');
                    }
    
                },
                onFailure: function(transport) {
                    if(typeof(reportAjaxError) == 'function') reportAjaxError(transport);
                    cpac.payroll.currentlySaving = '';
                }
            });
        },
    
        editModeOff: function (trRow, doSave, totalId, skipTotal)
        {
            Element.removeClassName(trRow, 'editMode');
            var editFields = $(trRow).select('.edit-field');
            var totalField = $(trRow).down('.total');
            var totalVal = 0;
            var prevTotalVal = 0;
            for (i=0; i<editFields.length; i++) {
                inputObj = editFields[i];
                spanObj = inputObj.previousSibling;
                if (doSave == 1 && inputObj.tagName == 'INPUT' && spanObj) {
                    floatVal = parseFloat(inputObj.value);
                    spanVal = parseFloat(spanObj.innerHTML);
                    isFee = Element.hasClassName(inputObj, 'fee');
                    if (isFee && !isNaN(floatVal)) {
                        spanObj.innerHTML = floatVal.toFixed(2);
                    } else if (isFee && isNaN(floatVal)) {
                        inputObj.value = spanObj.innerHTML;
                        floatVal = parseFloat(inputObj.value);
                        if (isNaN(floatVal)) {
                            floatVal = 0;
                        }
                    } else if (spanObj) {
                        spanObj.innerHTML = inputObj.value;
                    }
                    if (isFee) {
                        totalVal += floatVal;
                        prevTotalVal += (!isNaN(spanVal) ? spanVal : 0);
                    }
                }
                Element.hide(inputObj);
                if (spanObj) Element.show(spanObj);
            }
            if (doSave == 1 && totalField && !skipTotal) {
                totalField.innerHTML = totalVal.toFixed(2);
            }
            totalObj = totalId ? $(totalId) : null;
            if (doSave == 1 && totalObj) {
                var currentTotal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                currentTotal = currentTotal - prevTotalVal;
                currentTotal = currentTotal + totalVal;
                currentTotal = parseFloat(currentTotal);
                totalObj.innerHTML = currentTotal.toFixed(2);
    
                    // update global total
                var totalObj = $('total_payroll');
                if (totalObj) {
                    var currentTotal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                    currentTotal = currentTotal - prevTotalVal;
                    currentTotal = currentTotal + totalVal;
                    currentTotal = parseFloat(currentTotal);
                    totalObj.innerHTML = currentTotal.toFixed(2);
                }
            }
        },
    
        viewPlayersList: function(trId, playersList, linkObj )
        {
            Element.removeClassName(trId, 'last');
            if (!Element.hasClassName(trId, 'with-updates')) {
                Element.addClassName(trId, 'no-border');
            }
    
            Effect.toggle(playersList, 'blind', 0);
            linkObj.setAttribute('onclick', "cpac.payroll.hidePlayersList('" + trId + "', '" + playersList + "', this);");
            linkObj.innerHTML = 'hide list';
        },
    
    
        hidePlayersList: function(trId, playersList, linkObj )
        {
            Effect.toggle(playersList, 'blind', 0);
            Element.addClassName(trId, 'last');
            if (!Element.hasClassName(trId, 'with-updates')) {
                Element.removeClassName(trId, 'no-border');
            }
            linkObj.setAttribute('onclick', "cpac.payroll.viewPlayersList('" + trId + "', '" + playersList + "', this);");
            linkObj.innerHTML = 'view list';
        },
    
        addAdjustment: function (tableId, lastTrId, idTemplate, idTemplatePrefix)
        {
            try {
                var tableObj = $(tableId);
                var tbodyObj = tableObj.childNodes[0];
                var lastRow = $(lastTrId);
                var templateTr = $(idTemplatePrefix + idTemplate);
    
                var payrollId = 'js_' + this.adjustmentNum;
                this.adjustmentNum ++;
    
                var newTrObj = templateTr.cloneNode(true);
                newTrObj.setAttribute('id', idTemplatePrefix + payrollId);
                newTrObj.className = 'payroll_row last';
    
                var tds = newTrObj.getElementsByTagName('td');
                var regExp = new RegExp(idTemplate, 'g');
                for (i=0; i<tds.length; i++) {
                    tds[i].innerHTML = tds[i].innerHTML.replace(regExp, payrollId);
                }
    
                tbodyObj.insertBefore(newTrObj, lastRow);
                cpac.payroll.editModeOn(idTemplatePrefix+payrollId);
                var prevTr = newTrObj.previousSibling;
                if (prevTr && !Element.hasClassName(prevTr, 'even')) {
                    Element.addClassName(newTrObj, 'even');
                }
                $(newTrObj).show();
    
            } catch(e) {
                cpac.error(e);
            }
        },
    
        deleteAdjustment: function (trId, url, totalId)
        {
            try {
                var trObj = $(trId);
                var idObj = trObj.down('.id');
                var idVal = parseFloat(idObj.value);
                if (idVal != 0 && !isNaN(idVal)) {
                    callBack = function (result, trRow)
                    {
                        var editFields = $(trRow).select('.edit-field');
                        var totalVal = 0;
                        for (i=0; i<editFields.length; i++) {
                            inputObj = editFields[i];
                            spanObj = inputObj.previousSibling;
                            if (inputObj.tagName == 'INPUT' && spanObj) {
                                floatVal = parseFloat(spanObj.innerHTML);
                                isFee = Element.hasClassName(inputObj, 'fee');
                                if (isFee && !isNaN(floatVal)) {
                                    totalVal += floatVal;
                                }
                            }
                        }
                        if (totalVal != 0) {
                            var totalObj = $(totalId);
                            if (totalObj) {
                                var currentTotal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                                currentTotal = currentTotal - totalVal;
                                totalObj.innerHTML = currentTotal.toFixed(2);
    
                                    // update global total
                                var totalObj = $('total_payroll');
                                if (totalObj) {
                                    var currentTotal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                                    currentTotal = currentTotal - totalVal;
                                    totalObj.innerHTML = currentTotal.toFixed(2);
                                }
                            }
                        } else if (result.total != undefined) {
    
                            var totalObj = $(trObj).down('.total');
                            prevTotalVal = parseFloat(totalObj.innerHTML.replace(/\s/g, ''));
                            if (totalObj) {
                                // update global total
                                var globTotalObj = $(result.totalId);
                                if (globTotalObj) {
                                    var currentTotal = parseFloat(globTotalObj.innerHTML.replace(/\s/g, ''));
                                    currentTotal = currentTotal - prevTotalVal;
                                    currentTotal = currentTotal + parseFloat(result.total);
                                    currentTotal = parseFloat(currentTotal);
                                    globTotalObj.innerHTML = currentTotal.toFixed(2);
                                }
                                resTotal = parseFloat(result.total);
                                totalObj.innerHTML = resTotal.toFixed(2);
                            }
                        }
                        trObj.parentNode.removeChild(trObj);
                        
                        if(typeof colorPayrollTable === "function") colorPayrollTable();
                    }
                    this.processDataSaving(url, '&adj_id=' + idVal, trObj, callBack);
                } else {
                    trObj.parentNode.removeChild(trObj);
                }
             } catch(e) {
                cpac.error(e);
            }
        },
    
        cancelAdjustment: function (trId)
        {
            try {
                var trObj = $(trId);
                var idObj = trObj.down('.id');
                var idVal = parseFloat(idObj.value);
                if (idVal != 0 && !isNaN(idVal)) {
                    this.editModeOff(trId, 0);
                } else {
                    trObj.parentNode.removeChild(trObj);
                }
            } catch(e) {
                cpac.error(e);
            }
        },
    
        approve: function()
        {
            try {
                var eventsBlock = $('events_for_block');
                var ticketsBlock = $('tickets_for_block');
    
                var data = '&approve=1&events=' + (eventsBlock ? eventsBlock.innerHTML : '') +
                    '&tickets=' + (ticketsBlock ? ticketsBlock.innerHTML : '');
    
                var form = $('form');
    
                showResources(form, form.action, 'forErrors', null, data);
    
            } catch(e) {
                cpac.error(e);
            }
        },
    
        removeChanges: function(adjId)
        {
            try {
                var data = '&adj_id=' + adjId;
                var form = $j('#filter_form');
    
                $j.ajax({
                    url: '/payroll/remove-adjustment',
                    type: 'POST',
                    dataType : 'json',
                    data: form.serialize() + data,
                    success: function(response) {
                        if (!response.error) {
                            $j.post('/payroll/', form.serialize(), function(data) {
                                $j('#report-parent-container').html(data);
                            }, 'html');
                        } else {
                            $j.caAlert(response.error);
                        }             
                    },
                });
    
            } catch(e) {
                cpac.error(e);
            }
        }
    
    };
    
}